<!--
 * @Author: your name
 * @Date: 2020-11-23 10:05:07
 * @LastEditTime: 2024-10-29 11:12:21
 * @LastEditors: YangHan 1047143112@qq.com
 * @Description: In User Settings Edit
 * @FilePath: \kares_pad\src\components\schedule\ProgramManage.vue
-->
<template>
  <div class="program-manage">
    <subfield>
      <template slot="list">
        <trees :title="$t('cspm1')" type="GROUP" @getAssets="getAssets" :list="groupList"></trees>
      </template>
      <template slot="content">
        <enfold-ucd>
          <template slot="up">
            <div class="c-u-left">
              <el-button icon="el-icon-plus" size="mini" type="primary" @click="addProgramDv = true" round>{{
                $t('schedule.NewProgram') }}</el-button>
              <el-button icon="el-icon-delete" size="mini" type="danger" @click="deleteSelectedAll" round>{{
                $t('schedule.DeleteProgram') }}</el-button>
              <!-- <img src="@imgpub/public_add.png" @click="addProgramDv = true" class="icon" alt />
              <img src="@imgpub/public_delete.png" @click="deleteSelectedAll" class="icon" alt />-->
            </div>
            <div class="c-u-right">
              <el-input v-model="keyword" :placeholder="$t('public.search')" @focus="keyword = ''">
                <i slot="suffix" class="el-icon-search" @click="search(keyword)"></i>
              </el-input>
              <img src="@imgpub/public_list_sel.png" @click="listAndCardChange(true)" class="icon" alt
                v-if="listAndCard" />
              <img src="@imgpub/public_list_nor.png" @click="listAndCardChange(true)" class="icon" alt v-else />
              <img src="@imgpub/public_chart_sel.png" @click="listAndCardChange(false)" class="icon" alt
                v-if="!listAndCard" />
              <img src="@imgpub/public_chart_nor.png" @click="listAndCardChange(false)" class="icon" alt v-else />
            </div>
          </template>
          <template slot="center">
            <template v-if="listAndCard">
              <el-table ref="multipleTable" @selection-change="handleSelectionChange" :data="programList"
                style="width: 100%" height="100%" v-loading="loading" @row-click="tableRowClick">
                <!-- fabu_count > 0则是已经发布的节目或已经关联的节目,无法进行删除 -->
                <!-- <el-table-column type="selection" :selectable="(row)=>row.is_edit === 1" width="50"></el-table-column> -->
                <el-table-column type="selection" width="50"></el-table-column>
                <el-table-column :label="$t('schedule.Screenshot')" width="120">
                  <template slot-scope="scope">
                    <div class="operation">
                      <img style="width: 96px; height: 54px;" v-if="scope.row.damaged === 0" :src="scope.row.pimg"
                        alt />
                      <img style="width: 96px; height: 54px;" v-else src="@imgpub/damaged.png" alt />
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="name" :label="$t('schedule.ProgramName')"></el-table-column>
                <el-table-column prop="size_remark" :label="$t('schedule.Resolution')"></el-table-column>
                <el-table-column prop="group_name" :label="$t('schedule.Structure')"></el-table-column>
                <el-table-column prop="play_time" :label="$t('cbu7')">
                  <template slot-scope="scope">
                    {{ scope.row.play_time | playTime }}
                  </template>
                </el-table-column>
                <!-- <el-table-column prop="template_name" label="模板名称"></el-table-column> -->
                <el-table-column prop="create_time" :label="$t('schedule.CreationTime')"></el-table-column>
                <el-table-column :label="$t('schedule.operate')" width="180">
                  <template slot-scope="scope">
                    <div class="operation">
                      <el-tooltip class="item" effect="dark" :content="$t('cspm3')" placement="top">
                        <img src="@/assets/images/public/public_release.png" class="icon"
                          @click="programRelease(scope.$index, scope.row)" />
                      </el-tooltip>
                      <el-tooltip class="item" effect="dark" :content="$t('cspm4')" placement="top">
                        <img class="icon" src="@imgpub/public_detail.png" v-if="scope.row.is_edit === 0"
                          @click="TheProgramDetails(scope.$index, scope.row)" alt />
                      </el-tooltip>
                      <el-tooltip class="item" effect="dark" :content="$t('cspm5')" placement="top">
                        <img class="icon" v-if="scope.row.is_edit === 1" src="@imgpub/public_edit.png"
                          @click="handleEdit(scope.$index, scope.row)" alt />
                      </el-tooltip>
                      <el-tooltip class="item" effect="dark" :content="$t('cspm6')" placement="top">
                        <img class="icon" src="@imgpub/public_copy.png"
                          @click.stop="handleCopy(scope.$index, scope.row)" alt />
                      </el-tooltip>
                      <el-tooltip class="item" effect="dark" :content="$t('cspm7')" placement="top">
                        <img class="icon" src="@imgpub/public_delete.png" @click="handleDelete(scope.$index, scope.row)"
                          alt />
                      </el-tooltip>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </template>
            <template v-else>
              <ul class="program-list" v-infinite-scroll="programLoad">
                <li class="program-chile program-child-add flex-c-c" @click="addProgramDv = true">
                  <span>{{ $t('schedule.NewProgram') }}</span>
                </li>
                <li class="program-chile" v-for="program in programList" :key="program.id">
                  <program-item :program="program" @programControl="programControl"></program-item>
                </li>
                <li class="program-chile program-child-add flex-c-c" @click="programLoad"
                  v-show="programList.length !== 0">
                  <span>{{ programList.length ===
                    current ? $t('schedule.AllLoaded') : $t('schedule.materialsLoaded') }}</span>
                </li>
                <i v-for="index in 12" :key="'program-i-' + index"
                  style="width: 20%; max-width: 240px; height: 0px; margin: 0px 4px;"></i>
              </ul>
            </template>
          </template>
          <template slot="down" v-if="listAndCard">
            <pagination :current="current" :limit="limit" @currentChange="currentChange"></pagination>
          </template>
        </enfold-ucd>
      </template>
    </subfield>
    <del-dialog :dialogVisible="DelDialogVisible" @closeDialog="DelCloseDialog" :title="$t('schedule.DeleteMedia')">
      <div class="dd-dialog">{{ $t('schedule.DelProgram') }}</div>
    </del-dialog>
    <program-setting :addProgramDv="addProgramDv" @addProgramCd="addProgramCd"></program-setting>
    <del-dialog :dialogVisible="itemDelDialogVisible" @closeDialog="itemDelCloseDialog"
      :title="$t('schedule.DeleteMedia')">
      <div class="dd-dialog">{{ $t('schedule.DelProgram') }}</div>
    </del-dialog>
    <terminal-list :terminalListDV="terminalListDV" @publishTerminal="publishTerminal"
      :defaultPName="defaultPName"></terminal-list>
    <msg-dialog :dialogVisible="copyPlayVisible" @closeDialog="copyPlayDialog" title="复制节目">
      <div class="flex-b-c" style="width:100%">
        <span>节目名称:</span>
        <el-input v-model="copyPlayName" placeholder="请输入节目内容" style="width:280px"></el-input>
      </div>
    </msg-dialog>
  </div>
</template>

<script>
import subfield from '@/components/basics/Subfield'
import EnfoldUcd from '@/components/basics/EnfoldUCD'
import DelDialog from '@/components/basics/DelDialog'
import MsgDialog from '@/components/basics/MsgDialog'
import trees from '@/components/basics/Trees'
import pagination from '@/components/basics/Pagination'
import { mPagination } from "@/components/basics/mixins";
import ProgramSetting from "./children/ProgramSetting";
import ProgramItem from "./children/ProgramItem";
import TerminalList from './windows/children/TerminalList'
import { groupByTerminal } from "@/assets/scripts/publicFunction.js";
import { msFormatting } from "@/assets/scripts/dateFormatting.js";

export default {
  name: 'ProgramManage',
  mixins: [mPagination],
  data() {
    return {
      groupList: [],
      programList: [],
      loading: false,
      multipleSelection: false,
      DelDialogVisible: false,
      itemDelDialogVisible: false,
      addProgramDv: false,
      listAndCard: true,
      terminalListDV: false,
      defaultPName: "",
      copyPlay: null,
      copyPlayName: "",
      copyPlayVisible: false,
      // programInfor: {
      //   name: "play_" + new Date().getTime(),
      //   groupId: parseInt(this.$cookies.get("group_id")),
      //   resolutionId: 0,
      //   w: '',
      //   h: '',
      //   device: '',
      //   deviceType: 'Pandora'
      // }
    }
  },
  async created() {
    await this.$http.post("/admin/access/groupList", {}, data => {
      this.groupList = data;
    });
    await this.getProgramList();
    if (this.$route.params.type === "addProgram") {
      this.$nextTick(() => {
        setTimeout(() => {
          this.addProgramDv = true;
        }, 500);
      });
    }
  },
  mounted() {
    // 清空所有节目编辑数据
    this.$store.commit("VDR_LIST_CLEAR");
  },
  filters: {
    playTime(value) {
      return value ? msFormatting(value) : "--:--:--";
    }
  },
  methods: {

    getAssets(ids) {
      if (ids.type === "GROUP") {
        this.groupId = ids.id;
        this.groupIds = ids.ids;
        this.page = 1;
        this.current = 0;
        this.programList = [];
      }
      ids.id && this.getProgramList();
    },
    search(keyword) {
      this.keyword = keyword;
      this.getProgramList();
    },
    currentChange(val) {
      this.page = val;
      this.getProgramList();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      let ids = [];
      this.multipleSelection.forEach((item) => {
        ids.push(item.id);
      });
      this.delProgramIds = ids.join(",");
    },
    tableRowClick(row) {
      // console.log(row, column, event);
      // if (row.is_edit !== 1) { return; }
      this.$refs.multipleTable.clearSelection();
      this.$refs.multipleTable.toggleRowSelection(row);
    },
    TheProgramDetails(index, row) {
      console.log(index, row);
      const { name, group_id, size_remark, id } = row;
      this.enterProgram('look', name, group_id, size_remark, id);
    },
    handleEdit(index, row) {
      console.log(index, row);
      const { name, group_id, size_remark, id } = row;
      this.enterProgram('edit', name, group_id, size_remark, id);
    },
    // handleCopy(index, row) {
    //   const { id } = row;
    //   // console.log(index, row);
    //   this.$http.post("/admin/play/copy", { id }, () => {
    //     this.$msg({ message: this.$t('cspm8'), type: 'success' });
    //     this.getProgramList();
    //   });
    // },
    handleCopy(index, row) {
      this.copyPlay = row
      this.copyPlayName = row.name + "_" + parseInt(Math.random() * 100);
      this.copyPlayVisible = true;
    },
    copyPlayDialog(confirm) {
      if (confirm) {
        const { id } = this.copyPlay;
        this.$http.post("/admin/play/copy", { id, name: this.copyPlayName }, () => {
          this.$msg({ message: "节目复制成功!", type: 'success' });
          this.getProgramList();
        });
      }
      this.copyPlayVisible = false;
    },
    handleDelete(index, row) {
      this.delProgramIds = row.id;
      this.DelDialogVisible = true;
    },
    addProgramCd() {
      this.addProgramDv = false;
    },
    // 路由跳转到编辑页面
    /**
     * @description: 
     * @param {add/look/edit/copy} type
     * @param {节目名称} name
     * @param {*} groupId
     * @param {分辨率} resolution
     * @param {编辑节目id} id
     * @return {*}
     */
    enterProgram(type, name, groupId, resolution, id, deviceType) {
      let wh = resolution.split("x");
      this.$router.push({
        name: 'WindowsIndex',
        query: {
          type, //add/look/edit/copy
          name,
          groupId,
          resolution,
          id,
          w: wh[0],
          h: wh[1],
          deviceType
        }
      });
    },
    deleteSelectedAll() {
      if (!this.delProgramIds) {
        this.$msg({
          message: this.$t('cspm9'),
          type: 'warning'
        });
        return;
      }
      this.DelDialogVisible = true;
    },
    DelCloseDialog(isConfirm) {
      if (isConfirm) {
        this.programDelete(this.delProgramIds);
      }
      this.delProgramIds = "";
      this.DelDialogVisible = false;
    },
    programDelete(ids) {
      // 兼容新的接口，历史接口只需要传id
      // play_ids：节目id合集，使用逗号分隔；123, 234, 123
      // pimg_path_list：节目截图路径合集，逗号分隔
      // play_names：节目名合集，逗号分隔
      let idList = `${ids}`.split(',');
      let delProgramList = this.programList.filter((program) => {
        return idList.findIndex((id) => id == program.id) > -1;
      });
      // console.log(delProgramList);
      let play_ids = [];
      let pimg_path_list = [];
      let play_names = [];

      delProgramList.forEach((program) => {
        play_ids.push(program.id);
        pimg_path_list.push(program.pimg_path);
        play_names.push(program.name);
      });

      this.$http.post("/admin/play/del", {
        play_ids: play_ids.join(','),
        pimg_path_list: pimg_path_list.join(','),
        play_names: play_names.join(',')
      }, () => {
        this.getProgramList();
      });
    },
    listAndCardChange(val) {
      this.listAndCard = val;
      this.page = 1;
      this.current = 0;
      this.programList = [];
      this.getProgramList();
    },
    getProgramList(args = {
      group_ids: this.groupIds,
      limit: this.limit,
      page: this.page,
      key_word: this.keyword
    }) {
      this.loading = true;
      return this.$http.post("/admin/play/list", args, data => {
        if (this.listAndCard) {
          this.programList = data.list ? data.list : [];
        } else if (data.list && data.list.length > 0) {
          this.programList = this.programList.concat(data.list);
        }
        this.current = data.count ? parseInt(data.count) : 0;
        this.loading = false;
      });
    },
    programLoad() {
      if (this.programList.length < this.current) {
        setTimeout(() => {
          this.page += 1;
          this.getProgramList();
        }, 500)
      }
    },
    programControl(program, type) {
      this.itemProgram = program;
      if (type == 'delete') {
        console.log(program)
        this.itemDelDialogVisible = true;

      } else if (type == 'edit') {
        console.log(1111)
        this.handleEdit(1, program)
      } else if (type == 'detail') {
        this.TheProgramDetails(1, program)
      } else if (type == 'publish') {
        this.terminalListDV = true;
      }
    },
    itemGetProgramList() {
      this.$http.post('/admin/play/list', {
        group_ids: sessionStorage.getItem('group_ids'),
        limit: this.limit,
        page: this.page
      }, data => {
        this.current = data.count ? parseInt(data.count) : 0;
        this.programList = data.list;
      })

    },
    itemDelCloseDialog(isConfirm) {
      if (isConfirm) {
        this.$http.post('/admin/play/del', {
          play_ids: this.itemProgram.id,
          pimg_path_list: this.itemProgram.pimg_path,
          play_names: this.itemProgram.name
        }, () => {
          this.itemGetProgramList();
        })

      }
    },
    programRelease(index, row) {
      console.log(index);
      this.itemProgram = row;
      this.defaultPName = row.name;
      this.terminalListDV = true;
    },
    async publishTerminal(terminalList, adapter_screen, isAppend, publishName) {
      if (terminalList && terminalList.length > 0) {


        let listGroup = groupByTerminal(terminalList, "main_device").map((group) => {
          const { list, main_device } = group;
          return { main_device, ids: list.map((d) => d.id) };
        });

        await this.$http.post(`/admin/publish/addNew`, {
          group_id: this.$cookies.get('group_id'),
          play_ids: this.itemProgram.id,
          list_group: encodeURIComponent(JSON.stringify(listGroup)),
          play_mode: 0,
          publish_strategy: 0,
          publish_type: 1,
          isAppend: isAppend,
          adapter_screen: adapter_screen ? 1 : 0,
          publish_name: publishName
        }, () => {
          // 节目发布成功，跳转到节目列表
          this.$http.post("/admin/Command/getDownloadList", {}, res => {
            this.$store.commit("ISSUE_LIST", res);
          });
        });
        await this.$msg({ showClose: true, message: this.$t('cspm10'), type: 'success' });
        await this.$router.push({ name: 'ProgramManage', params: {} });



        // const list = groupByTerminal(terminalList, 'main_device')

        // list.forEach(async (item) => {
        //   let data = {
        //     group_id: this.$cookies.get('group_id'),
        //     play_ids: this.itemProgram.id,
        //     main_device: item.main_device,
        //     device_ids: item.list.map(terminal => terminal.id).join(","),
        //     play_mode: 0,
        //     publish_strategy: 0,
        //     publish_type: 1,
        //     isAppend: isAppend,
        //     adapter_screen: adapter_screen ? 1 : 0
        //   }
        //   await this.$http.post(`/admin/publish/add`, data, () => {
        //     // 节目发布成功，跳转到节目列表
        //     this.$http.post("/admin/Command/getDownloadList", {}, data => {
        //       this.$store.commit("ISSUE_LIST", data);
        //     });
        //   });

        // });
        // await this.$msg({ showClose: true, message: '节目发布成功！', type: 'success' });
        // await this.$router.push({ name: 'ProgramManage', params: {} });
        // console.log(terminalList, adapter_screen, isAppend)

        // let data = {
        //   group_id: this.$cookies.get('group_id'),
        //   play_ids: this.itemProgram.id,
        //   main_device: this.itemProgram.main_device,
        //   device_ids: terminalList.map(terminal => terminal.id).join(","),
        //   play_mode: 0,
        //   publish_strategy: 0,
        //   publish_type: 1,
        //   isAppend: isAppend,
        //   adapter_screen: adapter_screen ? 1 : 0
        // }

        // this.$http.post(`/admin/publish/add`, data, () => {
        //   // 节目发布成功，跳转到节目列表
        //   this.$msg({
        //     showClose: true,
        //     message: '节目发布成功！',
        //     type: 'success'
        //   });
        //   this.$http.post("/admin/Command/getDownloadList", {}, data => {
        //     this.$store.commit("ISSUE_LIST", data);
        //   });
        //   this.$router.push({
        //     name: 'ProgramManage',
        //     params: {}
        //   });
        // });

      }
      this.terminalListDV = false;
    }
  },
  components: {
    subfield,
    trees,
    EnfoldUcd,
    DelDialog,
    MsgDialog,
    pagination,
    ProgramSetting,
    ProgramItem,
    TerminalList
  }
}
</script>

<style lang="scss" scoped>
.program-manage {
  width: 100%;
  height: 100%;

  .c-u-right {
    display: flex;

    /deep/ .el-input__inner {
      height: 30px;
      line-height: 30px;
      border-radius: 15px;
    }

    /deep/ .el-input__suffix {
      line-height: 30px;
      color: #2fb3ff;
      font-size: 16px;
      right: 10px;
    }

    .icon {
      margin-right: 0px;
      margin-left: 25px;
    }
  }

  /deep/ .cell {
    font-size: 16px;
  }

  /deep/ .el-table__header-wrapper {
    .cell {
      font-size: 18px;
      color: #2fb3ff;
    }

    th:last-child>.cell {
      text-align: center;
    }
  }

  .operation {
    display: flex;
    justify-content: space-around;
    align-items: center;

    .icon {
      margin: 0px;
    }
  }

  .icon {
    width: 30px;
    height: 30px;
    margin-right: 25px;
  }

  .filter {
    padding-left: 12px;

    .title {
      text-align: center;
      font-size: 16px;
      color: #2fb3ff;
    }

    .title~.title {
      padding-top: 8px;
    }

    .content {
      padding-top: 8px;
    }
  }

  .msg-dialog {
    /deep/ .md-content {
      display: flex;
      flex-wrap: wrap;

      // height: calc(100vh - 200px);
      .form-item {
        width: 360px;
        // max-height: calc(100vh - 320px);
        // overflow-x: scroll;
        padding-right: 32px;

        .el-form {
          /deep/ .el-input__inner {
            border-radius: 20px;
          }

          .el-form-item__content {
            .el-button {
              margin-left: 16px;
            }
          }

          .el-form-item:last-child {
            margin-bottom: 0px;
          }

          // .el-form-item:nth-last-child(2) {
          //   margin-bottom: 0px;
          // }
        }

        .input-label {
          display: flex;
          justify-content: space-between;

          // margin-bottom: 22px;
          .el-button {
            margin-left: 0px !important;
          }
        }
      }

      .map-item {
        width: 436px;
        box-sizing: border-box;
      }
    }
  }

  .program-list {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    overflow: auto;

    .program-chile {
      cursor: pointer;
      width: 20%;
      max-width: 240px;
      border-radius: 4px;
      overflow: hidden;
      margin: 4px;
      background-color: #eefbff;
    }

    .program-child-add {
      cursor: pointer;
      user-select: none;
      padding-top: calc(11.2%);
      position: relative;

      span {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        white-space: nowrap;
      }
    }
  }
}
</style>

<style lang="scss" scoped>
.onLine {
  color: rgba($color: #0f0, $alpha: 0.8);
}

.offLine {
  color: rgba($color: #f00, $alpha: 0.8);
}
</style>
